/**
 * Exports
*/

export const API_URL = process.env.MIX_APP_API;